import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'src/app/core/services/cookie.service';
import Actions from 'src/app/core/constants/actions';
import { RecordsService } from 'src/app/core/services/records.service';
import { MessagesService } from 'src/app/core/services/messages.service';
import { InternalMessage } from 'src/app/core/models/internal.message';
import { NotifcationService } from 'src/app/core/services/notification.service';
import { NotifcationDto } from 'src/app/core/models/notification';
import { LanguageService } from 'src/app/core/services/Language.service';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  notificationItems: Array<{}>;
  openMobileMenu: boolean;
  notificationCount: number;
  language: string = 'en';
  checkshowall: boolean = false;
   notifications: NotifcationDto[] = [];

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(private router: Router, private authService: AuthenticationService, private translate: TranslateService, private cookieService: CookieService ,private recordsService: RecordsService,private notifcationService: NotifcationService,
    private messagesService: MessagesService,private languageService: LanguageService) { }

  ngOnInit() {
    this.translate.use(this.translate.getBrowserLang());
    // get the notifications
    this.openMobileMenu = false;


    this.recordsService.endConnection();
          this.recordsService.startConnection();
        
    
        this.notifcationService.getAllnotifcation().subscribe(result => {
          if (result.success) {
           this.language = this.cookieService.getCookie('lang');
        const langMap = { en: 1, fr: 2 };
        const selectedLangType = langMap[this.language] || 1; // Default to English if not found
        let filteredData = result.data.filter(item => item.lang_type === selectedLangType);     
        this.notificationCount = filteredData.length;    

      // Only take the top 5 notifications
      this.notifications = filteredData.slice(0, 5);  
      const savedcount = localStorage.getItem('notificationCount');
      if (savedcount !== null) {
        this.notificationCount = +savedcount; // Convert from string to number
      }else{
        this.notificationCount = filteredData.length; 
      }
              
          }
        });
        this.messagesService.getMessage().subscribe((msg: InternalMessage) => {    
        
              switch (msg.action) {
                
                  case Actions.newnotification:
                    this.checkshowall = false;
                    this.updateNotification(msg.parameters['count']);
                  break;
              }
            });
  }


  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.openMobileMenu = !this.openMobileMenu;
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
    this.router.navigate(['/account/login']);
  }

  showAllnotifiction() {
    this.notificationCount = 0;
    this.checkshowall = true;
    localStorage.setItem('notificationCount', '0');
    this.router.navigate(['/admin/notification']);
  }

  setEnglish(){
    this.translate.use(this.translate.getBrowserLang());
    this.cookieService.setCookie('lang', 'es', 100);
  this.language == 'en';
  this.languageService.setLanguage('en');
  this.fetchNotifications();
  } 

  setFrench(){
    this.translate.use('fr');
    this.cookieService.setCookie('lang', 'fr', 100);
    this.language == 'fr';
    this.languageService.setLanguage('fr');
    this.fetchNotifications();
  } 

  fetchNotifications() {
 
   
    this.notifcationService.getAllnotifcation().subscribe(result => {
     if (result.success) {       

         this.language = this.cookieService.getCookie('lang');
        const langMap = { en: 1, fr: 2 };
        const selectedLangType = langMap[this.language] || 1; // Default to English if not found
        let filteredData = result.data.filter(item => item.lang_type === selectedLangType);  
        if(this.checkshowall === true)   {
this.notificationCount = 0;   
        }else{
this.notificationCount = filteredData.length;   
        }
        
        this.notifications = filteredData.slice(0, 5);
            
     }
   });
  }

  updateNotification(count) {
    const savedcount = localStorage.getItem('notificationCount');
    
    if (savedcount !== null) {
      this.notificationCount = +savedcount; // Convert from string to number
    }else{
      this.notificationCount = count;
    }
    this.fetchNotifications();
   
  }
   
}
